import TickIcon from '@/common/assets/icons/tickIcon.svg?react';
import { BaseCheckBoxType } from '@/common/components/BaseCheckbox/BaseCheckBox.type';
import { css } from 'styled-system/css';
import { Box, Center } from 'styled-system/jsx';

export default ({ checked, disabled = false, id }: BaseCheckBoxType) => {
  return (
    <Box position="relative" width="16px" height="16px">
      <input
        id={id}
        checked={checked}
        type="checkbox"
        disabled={disabled}
        className={css({
          display: 'block',
          appearance: 'none',
          width: '100%',
          height: '100%',
          backgroundColor: {
            base: 'transparent',
            _checked: 'purple-primary',
            _disabled: 'gray-1',
          },
          borderRadius: '2px',
          border: {
            base: '1px solid {colors.black-4}',
            _checked: '1px solid {colors.purple-primary}',
            _disabled: '1px solid {colors.gray-1}',
          },
        })}
      />
      {checked ? (
        <Center
          onClick={(e) => e.stopPropagation()}
          className={css({
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
          })}
        >
          <TickIcon width="12px" height="9px" stroke={'white'} />
        </Center>
      ) : null}
    </Box>
  );
};
